import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {pagination_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {filterSimple_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {filterDropdown_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterDropdown_template";
import {validationsList_template} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";

declare var ko: any;

export class usersList_template extends vnTemplate{

    protected filter: filterSimple_template;
    public pagination: pagination_template;
    public roleFilter: filterDropdown_template;
    public validationsList: validationsList_template;


    protected getTemplateHtml(): string{

        return `
           
            <div class="sub-header w-justify" >

                <div class="w-left">
                       <div><label class="form-label" for="" >Role</label>` + this.roleFilter.getHtmlBuild()  +`</div>
                </div>
                <div class="w-center"></div>
                <div class="w-right"></div>
                
            </div>
            ` + this.validationsList.getHtmlBuild()  + `
            <div class="list-header w-justify">
                <div class="w-left"><button data-bind="click: onClickAdd, visible: permissions()['user_edit_advanced'].write" class="btn light border icon i-user-add" type="button">Add user</button></div>
                <div class="w-center">` + this.filter.getHtmlBuild() + `</div>
                <div class="w-right">`+ this.pagination.getHtmlBuild() +`</div>
            </div>
            
            <div class="w-list-results"  id="list-results">
            
                <table class="list-results">
                    <thead>
                        <tr>
                            <th><span></span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'firstName') }, css: { 'list-sort-desc': orderByAndDirection()=='firstName_DESC', 'list-sort-asc': orderByAndDirection()=='firstName_ASC' }" class="icon i-dropdown-simple">First Name</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'lastName') }, css: { 'list-sort-desc': orderByAndDirection()=='lastName_DESC', 'list-sort-asc': orderByAndDirection()=='lastName_ASC' }" class="icon i-dropdown-simple">Last Name</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'loginName') }, css: { 'list-sort-desc': orderByAndDirection()=='loginName_DESC', 'list-sort-asc': orderByAndDirection()=='loginName_ASC' }" class="icon i-dropdown-simple">User</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'email') }, css: { 'list-sort-desc': orderByAndDirection()=='email_DESC', 'list-sort-asc': orderByAndDirection()=='email_ASC' }" class="icon i-dropdown-simple">Mail</span></th>
                            <th><span class="icon list-sort-none" data-bind="event: { click: onClickReorder.bind($data, 'dateCreation') }, css: { 'list-sort-desc': orderByAndDirection()=='dateCreation_DESC', 'list-sort-asc': orderByAndDirection()=='dateCreation_ASC' }" class="">Created</span></th>
                        </tr>
                    </thead>
                    <tbody data-bind="foreach: users">
    
                        <tr class="cursor" data-bind="event: { click: $parent.onClickView }">
                            <td>
                                <div class="w-img"><img data-bind="attr:{src: pictureUrl}" alt=""></div>
                            </td>
                            <td><span data-bind="text: firstName"></span></td>
                            <td><span data-bind="text: lastName"></span></td>
                            <td><span data-bind="text: loginName"></span></td>
                            <td><span data-bind="text: email"></span></td>
                            <td><span data-bind="text: dateCreation"></span></td>
                            
                        </tr>
                        
                    </tbody>
                </table>
            </div>
            `;
    }

    protected initPartial(): void {

        this.filter = new filterSimple_template("filter", this.getTemplateViewModel(), this.caller);
        this.pagination = new pagination_template("pagination", this.getTemplateViewModel(), this.caller);
        this.pagination.getTemplateViewModel().itemPerPage = 25;
        this.roleFilter = new filterDropdown_template("roleFilter", this.getTemplateViewModel(), this.caller)
        this.validationsList = new validationsList_template("validationList", this.getTemplateViewModel(), this);
    }

    protected getTemplateName(): string{

        return "usersList-template";
    }

    protected getMainElementType(): string{

        return "div";
    }

    protected getMainElementClasses(): Array<string>{

    	return ["w-content"];
    }

    protected buildViewModel(): any{

        // define the viewmodel data/ functions
        let huit_neuf_this = this;
        return  {    orderBy: ko.observable("fullName")
                    ,orderByDirection: ko.observable("ASC")
                    ,users: ko.observableArray([ ])
                    ,orderByAndDirection: ko.observable("fullName_ASC")
                    ,isEarningsVisible: ko.observable(false)
                    ,isRoleFilterVisible: ko.observable(false)
                    ,permissions: ko.observableArray(this.initPermissions(['user_edit_advanced']))
                    ,onClickReorder : function(value, data, event){ huit_neuf_this.onClickReorder(value, data, event); }
                    ,onClickView : function(data, event){ huit_neuf_this.onClickView(data.id); }
                    ,onClickEdit : function(data, event){ huit_neuf_this.onClickEdit(data.id); }
                    ,onClickEarnings : function(data, event){ huit_neuf_this.onClickEarnings(data.id); }
                    ,onClickAdd : function(){ huit_neuf_this.onClickAdd(); }
                };
    }

    //
    // implementation of base class [vnTemplate]
    public getViewModelForRequest(){

        return {
             orderBy: this.getTemplateViewModel().orderBy
            ,orderByDirection: this.getTemplateViewModel().orderByDirection
            ,orderByAndDirection: this.getTemplateViewModel().orderByAndDirection
            ,filter : this.getTemplateViewModel().filter
            ,pagination: this.getTemplateViewModel().pagination
            ,roleFilter: this.getTemplateViewModel().roleFilter

        }
    }

    public onClickReorder(value, data, event){

        data.orderBy(value);
        //if column has already been sorted, flip the direction
        if (data.orderByAndDirection().includes(value)){
            if( data.orderByDirection() == "DESC" ){
                data.orderByDirection("ASC");
            }
            else{
                data.orderByDirection("DESC");
            }
        }
        else{
            //default column sort direction
            data.orderByDirection("DESC");
        }

        data.orderByAndDirection(value + "_" + data.orderByDirection());

        this.caller.userListReorder();
    }

    public onClickView(id){

        this.caller.viewUserProfile(id);
    }

    public onClickEdit(id){

        this.caller.editUser(id);
    }

    public onClickEarnings(id){

        this.caller.earningsUser(id);
    }

    public onClickAdd(){

        this.caller.addUser();
    }

    public setUsers(users: Array<{pictureUrl: string ,fullName: string ,loginName: string ,email: string ,dateCreation : string}>): void{

        this.getTemplateViewModel().users(users);
    }

    public setRoleFilterVisible(isRoleFilterVisible: boolean){

        this.getTemplateViewModel().isRoleFilterVisible(isRoleFilterVisible);
    }

    public setPermissions(permissions){

        this.getTemplateViewModel().permissions(permissions);
    }


}



// WEBPACK FOOTER //
// ./js/components/templates/usersList_template.ts